/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Controls/Rate': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M20.315 17.552l.872 5.231-5.181-1.787-5.183 1.787.872-5.231-3.498-4.372 4.979-.764 2.83-4.529 2.828 4.53 4.979.763-3.498 4.372zm7.103-6.034l-7.26-1.112-3.922-6.277a.272.272 0 0 0-.462 0l-3.922 6.277-7.26 1.112a.274.274 0 0 0-.172.442l4.957 6.197-1.24 7.44a.274.274 0 0 0 .359.304l7.51-2.59 7.508 2.59c.196.066.393-.1.36-.305l-1.241-7.44 4.957-6.196a.274.274 0 0 0-.172-.442z"/>'
  }
})
